import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Table } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";

function DownloadList(props) {
  const [downloads, setDownloads] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // Todo: get downloads
  const getDownloads = () => {
    setIsLoading(true);
    apiReq(url.GET_DOWNLOADS_ITEMS, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setDownloads(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getDownloads();
  }, []);

  // handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        apiReq(url.DELETE_DOWNLOADS_ITEMS + id, {}, "delete", {
          Authorization: `Bearer ${user.user?.token}`,
        })
          .then((res) => {
            if (res.success) {
              Swal.fire("Deleted!", res.message, "success");
              getDownloads();
            }
          })
          .catch((err) => {
            console.log("err>>>", err);
          });
      }
    });
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (text, record, index) => (
        <span>
          <img
            src={record.image}
            alt={record.title}
            style={{ width: "100px", height: "100px" }}
          />
        </span>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (text, record, index) => (
        <span>
          {record.category ? (
            record.category.title
          ) : (
            <span className="text-danger">No category found</span>
          )}
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <span>{text.length > 100 ? text.slice(0, 100) + "..." : text}</span>
      ),
    },
    {
      title: "File",
      dataIndex: "file",
      key: "file",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Date",
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <div className="d-flex">
          <Link
            className="btn btn-success btn-sm mr-2"
            to={`/downloads/list/edit/${record._id}`}
            //   onClick={() => handleEdit(record)}
          >
            <i className="ri-pencil-line"></i>
          </Link>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(record._id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Downloads</h5>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end">
                    <Link
                      to="/downloads/list/create"
                      className="btn btn-primary"
                    >
                      Add new item
                    </Link>
                  </div>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={downloads}
                  bordered
                  loading={isLoading}
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default DownloadList;
